$( document ).ready(function() {
      getProductsFromUrlParams();

function extractTextBetween(subject, start, end) {
	try{
		return subject.split(start)[1].split(end)[0];
	} catch(e){
		console.log("Exception when extracting text", e);
	}
}
  
function updateUrlParams(type, collection, sort_value) {
  if (type) {
      window.history.replaceState(null, null, `?${$.param({
             q: type,
        sort: sort_value
    })}`);
  }

  if (collection) {
      window.history.replaceState(null, null, `?${$.param({
       sort: sort_value,
      collection: collection
    })}`);
  }

  if (collection && type) {
      window.history.replaceState(null, null, `?${$.param({
              q: type,
      sort: sort_value,
      collection: collection
    })}`);
  }
}

function setActiveSortItem(value) {
  $(".sort-select li").each(function(){
      const $this = $(this);
      if($this.attr('value').indexOf(value) !== -1){
          $(".sort-select").children('.init').html($this.html());
      }
  })
}

function setActiveTypeItem(value) {
  $("#category li").each(function(){
      const $this = $(this);
      if($this.attr('value') === value){
          $this.addClass("active");
      }
  })
}

function getProductsFromUrlParams() {
  const url = window.location.href;
  const searchParams = new URLSearchParams(window.location.search);
  const sort = searchParams.get('sort');
  const sortBy = searchParams.get('sort_by');
  type = searchParams.get('q');
  if (!!sort || !!sortBy) {
    setActiveSortItem(sort || sortBy);
  }

  if (type) {
    setActiveTypeItem(type);
     $("#category").children('.init').html(type);
  }
}


$(".sort-select").on("click", ".init", function() {
    $(this).closest("ul").children('li:not(.init)').toggle();
});

const allOptions = $(".sort-select").children('li:not(.init)');
$(".sort-select").on("click", "li:not(.init)", function(e) {
    console.log("clicked");
    allOptions.removeClass('active');
    $(this).addClass('active');
    $(".sort-select").children('.init').html($(this).html());
    allOptions.toggle();
  
    sort = $(this).attr("value");
    const searchParams = new URLSearchParams(window.location.search);
    const type = searchParams.get('q');
    const collectionFromParams = searchParams.get('collection');

    const url = window.location.href;

    if (url.includes("/types?")) {
      if (type && !collectionFromParams ) {
      window.location = `/collections/types?q=${type}&sort_by=${sort}`;
      }
      if (type && collectionFromParams ) {
            window.location = `/collections/types?q=${type}&sort=${sort}&collection=${collectionFromParams}`;
      }
    } else {
      const collection = window.location.pathname.split('collections/').pop();
      if (collection.includes('collections')) {
                window.location = `/collections/shop?sort_by=${sort}`;
      } else {
            window.location = `/collections/${collection}?sort_by=${sort}`;
      }
    }
});

$("#category").on("click", ".init", function() {
  if ($(window).width() < 768)  {
        $(this).closest("ul").children('li:not(.init)').toggle();
  }
});

const allTypeOptions = $("#category").children('li:not(.init)');

$("#category li:not(.all-items):not(.init)").on("click", function() {
  if ($(window).width() < 768)  {
    allTypeOptions.removeClass('active');
    $(this).addClass('active');
    $("#category").children('.init').html($(this).html());
    allTypeOptions.toggle();
  }

    const type = $(this).attr("value");
    const searchParams = new URLSearchParams(window.location.search);
    const sort = searchParams.get('sort');
  const sortBy = searchParams.get('sort_by');
    const collectionFromParams = searchParams.get('collection');
  
    if (collectionFromParams && !sort) {
          window.location = `/collections/types?q=${type}&collection=${collectionFromParams}`;
    }
    if (collectionFromParams && sort) {
          window.location = `/collections/types?q=${type}&sort=${sort}&collection=${collectionFromParams}`;
    }
    if (!collectionFromParams) {
      const collection = window.location.pathname.split('collections/').pop();
      if (collection.includes('collections')) {
        if (sort) {
           window.location = `/types?q=${type}&sort=${sort}&collection=shop`;
        }         
      } else {
        if (collection != 'types') {
          window.location = `/collections/types?q=${type}&sort=${sort || sortBy}&collection=${collection}`;
        } else {
          window.location = `/types?q=${type}&sort_by=${sort || sortBy}`;
        }
      }
    }
});

  // $('.password-header').on('click', '.password-button', function(e) {
  //   e.preventDefault();
  //  const input = $('#Password').val();

  //  fetch(`/password?form_type=storefront_password&password=${input}`).then(response => {
  //   return response.text();
  //  }).then(function (html) {
  //      console.log(html);
  //      if (html.includes('PasswordLoginForm-password-error')) {
  //         var match = extractTextBetween(html, '<div id="StartPassword"></div>', '<div id="EndPassword"></div>');
  //         document.getElementById("shop-password").innerHTML = match;
  //      } else {
  //         const currentPage = window.location.href;
  //         window.location.href = 'https://99based.com/collections/daily-garms';
  //      } 
  //   }).catch(function (err) {
  //       console.warn('Something went wrong.', err);
  //   });
  // });
});